import { Injectable } from '@angular/core';
import { UserDataSyncService } from '@/app/platform/platform-core/user/services/user-data-sync.service';

/**
 * Hydrateert de per-user app-instellingen en app-status vanaf de backend naar
 * localStorage vóór de eerste render (na de user-load, zie
 * `PlatformInitializer`). Fouten blokkeren het opstarten nooit: localStorage
 * blijft dan leidend (offline-gedrag).
 */
@Injectable({
  providedIn: 'root'
})
export class UserDataSyncInitializer {
  constructor(private readonly userDataSyncService: UserDataSyncService) {}

  async init() {
    try {
      await this.userDataSyncService.initialize();
    } catch (error: unknown) {
      console.warn('userDataSync: initialisatie mislukt; lokale opslag blijft leidend.', error);
    }
  }
}
